import {
  ANGLED_HIGHWAY_MINIMUM_LENGTH,
  AREA_MINIMUM_SIZE,
  OBSTACLE_MINIMUM_SIZE,
  WALL_MINIMUM_LENGTH,
} from '@/modules/canvas/constants/elements';
import { Vector2 } from 'three';

import { DrawableToolId } from '@/modules/toolbar/types';
import { supportsLoadCarriers } from './loadCarrier';

export function getMinimumSizeByToolId(type: DrawableToolId): number {
  let minSize: number;
  switch (type) {
    case 'wall':
      minSize = WALL_MINIMUM_LENGTH;
      break;
    case 'highway_angled':
      minSize = ANGLED_HIGHWAY_MINIMUM_LENGTH;
      break;
    case 'obstacle':
      minSize = OBSTACLE_MINIMUM_SIZE;
      break;
    default:
      minSize = AREA_MINIMUM_SIZE;
      break;
  }
  return minSize;
}

/**
 * returns the minimum size for a shape, taking into account the provided max dimensions
 *
 * @param shape
 * @param vehiclesMaxDimensions represents the largest width, and largest length of a series of vehicle dimensions.
 * @param loadCarriersMaxDimensions represents the largest width, and largest length of a series of load carrier dimensions.
 */
export function getMinimumSize(
  size: Vector2,
  type: DrawableToolId,
  vehiclesMaxDimensions?: { width: number; length: number },
  loadCarriersMaxDimensions?: { width: number; length: number },
): {
  width: number;
  height: number;
} {
  const minSize = getMinimumSizeByToolId(type);
  const isHorizontal = size.x > size.y;
  if (supportsLoadCarriers(type) && loadCarriersMaxDimensions) {
    const minWidthAreasWithLoad = loadCarriersMaxDimensions.width;
    const minHeightAreasWithLoad = loadCarriersMaxDimensions.length;

    return {
      width: isHorizontal ? minHeightAreasWithLoad : minWidthAreasWithLoad,
      height: isHorizontal ? minWidthAreasWithLoad : minHeightAreasWithLoad,
    };
  }
  if (vehiclesMaxDimensions) {
    const minWidthAreasNoLoad = vehiclesMaxDimensions.width;
    const minHeightAreasNoLoad = vehiclesMaxDimensions.length;

    return {
      width: isHorizontal ? minHeightAreasNoLoad : minWidthAreasNoLoad,
      height: isHorizontal ? minWidthAreasNoLoad : minHeightAreasNoLoad,
    };
  }

  return {
    width: minSize,
    height: minSize,
  };
}
